import "./index.css";
import GdnAdTemplate from "../GdnAdTemplate";

/**
 * Google Display Network — 160×600 wide skyscraper (rendered @2× = 320×1200).
 * Stacked logo; shared body in ../GdnAdTemplate.
 */
const WideSkyscraperAds = ({id, zoom}) => <GdnAdTemplate id={id} zoom={zoom} variant="stacked" />;

export default WideSkyscraperAds;
